var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMapLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0001 21.3333C18.9456 21.3333 21.3334 18.9455 21.3334 16C21.3334 13.0545 18.9456 10.6667 16.0001 10.6667C13.0546 10.6667 10.6667 13.0545 10.6667 16C10.6667 18.9455 13.0546 21.3333 16.0001 21.3333Z",
    fill: "url(#paint0_linear_1090_2994)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3334 5.42532V2.66666H14.6667V5.42532C12.3205 5.7249 10.14 6.79489 8.46751 8.46742C6.79498 10.1399 5.72499 12.3204 5.42541 14.6667H2.66675V17.3333H5.42541C5.72455 19.6798 6.7944 21.8604 8.46701 23.5331C10.1396 25.2057 12.3203 26.2755 14.6667 26.5747V29.3333H17.3334V26.5747C19.6799 26.2757 21.8607 25.206 23.5334 23.5333C25.2061 21.8607 26.2758 19.6799 26.5747 17.3333H29.3334V14.6667H26.5747C26.2756 12.3202 25.2058 10.1395 23.5332 8.46692C21.8605 6.7943 19.6799 5.72446 17.3334 5.42532ZM16.0001 24C11.5881 24 8.00008 20.412 8.00008 16C8.00008 11.588 11.5881 7.99999 16.0001 7.99999C20.4121 7.99999 24.0001 11.588 24.0001 16C24.0001 20.412 20.4121 24 16.0001 24Z",
    fill: "url(#paint1_linear_1090_2994)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1090_2994",
    x1: 10.8191,
    y1: 11.2222,
    x2: 16.5229,
    y2: 23.1829,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1090_2994",
    x1: 3.0477,
    y1: 4.05555,
    x2: 17.3072,
    y2: 33.9573,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapLocation);
export default __webpack_public_path__ + "static/media/map-location.81994213d44bb1da6bff7e2f1d1b4321.svg";
export { ForwardRef as ReactComponent };